import React, { FC } from 'react'
import { Switch } from 'react-router-dom'

import Home from 'components_new/pages/Home'

import { useIsAuthenticated } from 'redux/hooks/SignedInAccount'

import AuthRoute from './AuthRoute'

const Routes: FC = () => {
  const isAuthenticated = useIsAuthenticated()

  return (
    <Switch>
      <AuthRoute
        isAuthenticated={isAuthenticated}
        Component={() => <Home />}
        path={'/'}
      />
    </Switch>
  )
}

export default Routes
